import React from 'react';

import { Dropdown } from '@zapier/design-system';

import { REQUEST_METHODS } from 'app/developer-v3/constants';

import { RequestMethodTypes } from 'app/developer-v3/types/request';

type Props = {
  onChange: (options: RequestMethodTypes) => void;
  defaultValue: RequestMethodTypes;
};

function RequestMethodPicker({ onChange, defaultValue }: Props) {
  const defaultItem = REQUEST_METHODS.find(
    requestMethod => requestMethod.value === defaultValue
  );

  return (
    <Dropdown
      initialSelectedItem={defaultItem}
      items={REQUEST_METHODS}
      onChange={itemNext => onChange(itemNext.value as RequestMethodTypes)}
      size="large"
    />
  );
}

export default RequestMethodPicker;
